
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#F2994A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 14.904c0-.5.408-.904.912-.904h15.805c.504 0 .912.405.912.904s-.408.903-.912.903H10.912a.908.908 0 01-.912-.903zm0 4.819c0-.5.408-.904.912-.904h10.942c.504 0 .912.405.912.904s-.408.904-.912.904H10.912a.908.908 0 01-.912-.904zm0 4.82c0-.5.408-.904.912-.904h7.295c.503 0 .912.404.912.903a.908.908 0 01-.912.904h-7.295a.908.908 0 01-.912-.904zm15.502-4.459c.47 0 .85.378.85.844v2.77h2.797c.47 0 .851.378.851.844a.847.847 0 01-.851.843h-2.796v2.772A.847.847 0 0125.5 29a.847.847 0 01-.85-.843v-2.771h-2.797a.847.847 0 01-.851-.844c0-.466.381-.843.851-.843h2.797v-2.771c0-.466.38-.844.85-.844z","fill":"#fff"}})])
          )
        }
      }
    